export default __webpack_public_path__ + "static/media/igLogo.6719fe67.png";